import React from 'react'

import Layout from 'components/Layout'
import SEO from 'components/SEO'
import styled from 'util/style'

const Privacy = styled.div`
  max-width: 60%;
  line-height: 2em;
  margin: 0 auto;
`

export function PrivacyPage({ data }) {

  return (
    <Layout>
      <SEO title="Privacy" />

        <Privacy>
            <h2>Privacy verklaring</h2>
            
            {data && data.prismicAboutPage &&
                <div dangerouslySetInnerHTML={{ __html: data.prismicAboutPage.data.privacy.html }} />
            }
        </Privacy>
    </Layout>
  )
}

export const query = graphql`
    query privacy {
        prismicAboutPage {
            data {
                privacy {
                    html
                }
            }
        }
    }
`

export default PrivacyPage
